// AI Generated Test
import { Component, OnInit, inject } from '@angular/core';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'pages-policy-ignored-pages',
    standalone: false,
    template: `
        <page-header
            [icon]="['SIDEMENUES', 'POLICIES', 'IGNORED_PAGES'] | monIcons"
            [header]="'Pages with Ignored Policies' | translate"
            [subHeader]="subheaderTranslation">
        </page-header>

        <mon-tabs
            (onSearch)="onSearch($event)"
            [search]="search"
            [minSearchLength]="1"
            [showSearch]="true"
            [showFiltersBtn]="showFilters"
            [(isFiltersOpen)]="isFiltersOpen">
        </mon-tabs>

        <div class="card panel-monsido-card">
            <div class="card-body">
                <div class="px-4">
                    <table-container
                        [collection]="pages"
                        (onPageChange)="onPageChange($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [progress]="progress">
                        <table-container-top>
                            <div class="outer-b merge-r-16 merge-l-16 merge-t-10" *ngIf="isFiltersOpen">
                                <table-filters
                                    [(open)]="isFiltersOpen"
                                    [(ngModel)]="filters"
                                    name="filters"
                                    [filters]="availableFilters"
                                    (onChanges)="onFiltersChanges($event)">
                                </table-filters>
                            </div>
                        </table-container-top>
                        <table class="table table-hover table-fixed table-with-labels">
                            <thead>
                            <tr>
                                <th monTableSort
                                    [monSortBy]="'title'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{ 'Title and URL' | translate }}
                                </th>
                                <th class="col-sm-4 col-md-4 text-right">
                                    {{ 'Ignored checks' | translate }}
                                </th>
                                <th class="col-sm-4 col-md-4 text-right"
                                    monTableSort
                                    [monSortBy]="'ignored_policies_count'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    {{ 'Priority' | translate }}
                                </th>
                                <th class="col-sm-8 col-lg-6">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let page of pages">
                                <td>
                                    <div class="text-ellipsis">
                                        <mon-url-title
                                            *ngIf="!pageDetailsIsAvailable"
                                            [title]="page.title"
                                            [url]="page.url"
                                            [active]="false">
                                        </mon-url-title>
                                        <url-title-page-details
                                            [target]="'page-details-section-policies'"
                                            *ngIf="pageDetailsIsAvailable"
                                            [page]="page"
                                            (onClose)="onPageDetailsClose()"
                                            [title]="page.title"
                                            [url]="page.url"
                                            [active]="false">
                                        </url-title-page-details>
                                    </div>
                                    <label-table
                                        [assignedLabels]="page.labels"
                                        *ngIf="showLabels"
                                        [existingLabels]="labels"
                                        (getLabels)="getLabels()"
                                        (onUpdateLabel)="updateLabels(page)">
                                    </label-table>
                                </td>
                                <td class="text-v-middle text-right">
                                    {{page.ignored_policies_count}}
                                </td>
                                <td class="text-v-middle text-right">
                                    <mon-priority class="vcenter"
                                        [priority]="page.priority_score_as_text">
                                    </mon-priority>
                                </td>
                                <td class="text-v-middle text-right">
                                    <div class="d-flex flex-wrap align-items-center justify-content-end">
                                        <table-page-details
                                            ngbTooltip="{{'Open page details' | translate}}"
                                            [triggers]="'focus hover'"
                                            [target]="'page-details-section-policies'"
                                            [page]="page"
                                            (callBack)="onPageDetailsClose()">
                                        </table-page-details>
                                        <mon-extension-visual-link-button class="ml-1" [page]="page" [type]="'acc'"></mon-extension-visual-link-button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class PagesPolicyIgnoredPagesComponent extends BaseContainerComponentController implements OnInit {
    pages: any = [];
    subheaderTranslation: string = '';
    progress: any;
    pageDetailsIsAvailable: boolean = false;

    private policyRepoService = inject(PolicyRepoService);
    private translateService = inject(TranslateService);
    private activeFeatureService = inject(ActiveFeatureService);

    constructor () {
        super({ table: true, labels: true, pages: true });
    }

    ngOnInit () {
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.pages = [];
        this.subheaderTranslation = '';
        this.currentSort = {
            by: 'ignored_policies_count',
            direction: 'desc',
        };

        this.getPage();
    }

    getSubHeaderDescription () {
        const total = this.pages.total || this.pages.length;
        this.subheaderTranslation = this.translateService.getPlural(
            total,
            '1 page with one or more ignored checks',
            '[[$count]] pages with ignored checks',
            { $count: total },
            '',
        );
    }

    override getPage () {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            search: this.search || null,
        };

        const updatedParams = this.updateParamsWithFilters(params);

        this.progress = this.policyRepoService.getPagesWithPolicyIgnoredChecks(updatedParams).then((data: any) => {
            // Backend does not paginate this endpoint — apply client-side pagination
            if (data.total === undefined) {
                const start = (this.page - 1) * this.pageSize;
                this.pages = data.slice(start, start + this.pageSize);
                this.pages.total = data.length;
                this.pages.currentPage = this.page;
                this.pages.perPage = this.pageSize;
            } else {
                this.pages = data;
            }
            this.getSubHeaderDescription();
        }, () => {});
    }

    onFiltersChanges (changes: any) {
        this.updateFilters(changes);
        this.getPage();
    }
}
